import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";
import type { StudentEvent } from "./events";

/**
 * Fetch the events of one month for the calendar view.
 * Backend: GET /api/user/calendar/getEventsMonthly
 */
export const GetEventsMonthly = async (
  currentYear: string,
  current_month: string,
): Promise<ServiceResponse<StudentEvent[]>> => {
  const auth = store.getState().auth as any;
  try {
    const resp = await service.call("GET", "api/user/calendar/getEventsMonthly", {
      current_year: currentYear,
      current_month,
      society: auth.filterSociety,
      university: auth.filterUniversity,
      user_id: auth.user?.id,
    });
    return resp;
  } catch (err) {
    console.error(`GetEventsMonthly ${err}`);
    return { status: -1 };
  }
};
